import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { financingLp } from "@/content/landing/financing";
import { pageSeo } from "@/lib/seo";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpFinancingPage = lazyNamed(
  () => import("@/components/landing/lp-financing"),
  "LpFinancing",
);

const PATH = "/financing";

export const Route = createFileRoute("/financing")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: financingLp.metaTitle,
      description: financingLp.metaDescription,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "website",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: financingLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpFinancingPage,
});
